// 接口请求路径
// var api_url = "https://website.api.zwcpartners.com/admin"; // 正式
var api_url = '/sysapic/admin'; // 测试
// api_url = 'http://zw.bjztyh.com/sysapic/admin';
// oss
var accessKeyId = 'LTAI5tAnCPMoJ4CtV97idN3y';
var accessKeySecret = 'S9MEUKXic4X2ewHOM8MBuTASXBPGgR';
var bucket = 'zhongwei-capital';
var region = 'oss-cn-shanghai';
var bucket_url = 'https://zhongwei-capital.oss-cn-shanghai.aliyuncs.com/';

var setOssFile = function (e) {
  var url_name = 'website-upload/' + formatTime(new Date, 4) + '/';
  const fileName = url_name + e.file.uid + e.file.name;
  return fileName;
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

const formatTime = (date, e) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  if (e == 1) {
    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
  } else if (e == 2) {
    return [year, month, day].map(formatNumber).join('.');
  } else if (e == 3) {
    return [year, month, day].map(formatNumber).join('-');
  } else if (e == 4) {
    return year + '' + month + '' + day
  }
}

var toTop = function () {
  document.getElementsByClassName('ant-layout')[1].scrollTop = 0;
}





export default {
  api_url,
  accessKeyId,
  accessKeySecret,
  bucket,
  region,
  bucket_url,
  formatTime,
  toTop,
  setOssFile
}



// WEBPACK FOOTER //
// ./src/util/common.js